import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'

import { IGlasses, Dictionary } from '../store'
import { useStore } from '../hooks'
import { Text, Image } from './UI'
import Sizes from './Menu/Sizes'
import { getParam } from '../utility'

const SMenu = styled.div<{ hasSizes: boolean }>`
    background-color: white;
    display: grid;

    grid-template-rows: min-content min-content auto;

    ${p => p.hasSizes && css`
        grid-template-rows: min-content min-content min-content auto;
    `}

    overflow: hidden;


    @media only screen and (max-width: ${p => p.theme.mobileWidth}) {
        grid-template-columns: 100%;
        grid-template-rows: min-content auto;

        ${p => p.hasSizes && css`
            grid-template-rows: min-content min-content min-content auto;
        `}
    }

`

const STitle = styled.div`
    padding: .6rem;
    display: grid;
    grid-auto-flow: column;
    border-bottom: 1px solid ${p => p.theme.colors.medium};
`

const SInfo = styled.div`
    display: grid;
    padding: 1rem;
    overflow: auto;

    @media only screen and (max-width: ${p => p.theme.mobileWidth}) {
        display: none;
    }
`

const SPair = styled.div`
    display: grid;
`

const SItems = styled.div`
    overflow-y: auto;
    @media only screen and (max-width: ${p => p.theme.mobileWidth}) {
        overflow-y: hidden;
        overflow-x: auto;
        grid-auto-flow: column;
    }
`

const SGrid = styled.div`
    display: grid;
    grid-gap: .5rem;
    padding-bottom: 1rem;
    @media only screen and (max-width: ${p => p.theme.mobileWidth}) {
        grid-auto-flow: column;
    }
`

const SItem = styled.div<{ selected: boolean }>`
    cursor: pointer;
    opacity: ${p => p.selected ? 1 : .3};

    :hover {
        opacity: 1;
    }

    padding: .2rem 1.5rem;
    height: 4.5rem;
    transition: .4s;
    @media only screen and (max-width: ${p => p.theme.mobileWidth}) {
        padding: .2rem;
        width: 8rem;
        height: 4.5rem;
    }
`

interface IState {
	modelKey: string,
	nameText: string,
	hasSizes?: boolean,
	sizes?: Dictionary<string>,
	selectedSize?: string
}

export default function Menu(props: { selectGlasses: (glasses: string) => void, selected: string, selectSizeHandler: (model: string, key: string) => void }) {
	const store = useStore()
	const [state, set] = useState<IState>({
		modelKey: getParam('model'),
		nameText: 'Loading...',
	})

	const glasses: IGlasses = store?.state?.glasses?.SizeReferences ?
		store.state?.otherSizes[state.selectedSize] ?? {} as IGlasses :
		store?.state?.glasses ?? {} as IGlasses

	useEffect(() => {
		const defaultGlasses = store?.state?.glasses ?? {} as IGlasses // Get glasses reference.
		// Check if has sizes. Get sizes.
		set(p => ({
			...p,
			// hasSizes: defaultGlasses?.SizeReferences != undefined,
			hasSizes: false, // Disable sizes feature.
			sizes: {
				[defaultGlasses?.DefaultSizeName]: p.modelKey, // Add default size.
				...(defaultGlasses?.SizeReferences ? defaultGlasses.SizeReferences : {}) // Add the rest.
			}
		}))
	}, [store])

	useEffect(() => {
		// Set default selected size.
		set(p => ({
			...p,
			selectedSize: Object.keys(p.sizes)[0]
		}))
	}, [state.sizes])

	useEffect(() => {
		// Send selected size to Layout parent.
		if (state.sizes && state.hasSizes) props.selectSizeHandler(state.selectedSize, state.sizes[state.selectedSize])
	}, [state.selectedSize])

	useEffect(() => {
		// Set error message.
		const timeOut = setTimeout(() => {
			set(p => ({ ...p, nameText: 'Frame not Available' }))
		}, 2000)

		return () => clearTimeout(timeOut)
	}, [])

	function getSpecs() {
		if (glasses?.SpecKeys)
			return Object.entries(glasses.SpecKeys).map(([key, spec]) =>
				<SPair key={key}>
					<Text primary bold>{spec.Name}</Text>
					<Text medium bold>{glasses.Styles[props.selected].SpecValues[key].String}</Text>
				</SPair>
			)

	}

	function getThumbnails() {
		if (glasses?.Styles)
			return Object.entries(glasses.Styles).map(([key, style]) =>
				<SItem
					key={key}
					selected={key === props.selected}
					onClick={() => props.selectGlasses(key)}
				>
					<Image url={`${state.hasSizes ? state.sizes[state.selectedSize] : state.modelKey}/${style.InternalName}.png`} />
				</SItem>
			)
	}

	return (
		<SMenu hasSizes={state.hasSizes}>
			<STitle>
				{/* <Text middle subTitle bold primary style={{ fontFamily: 'Century Gothic' }}>{glasses.Name ?? state.nameText}</Text> */}
				<Text middle subTitle bold primary>{glasses.Name ?? state.nameText}</Text>
				<Text medium bold bottom>{glasses.Subtitle ?? ''}</Text>
			</STitle>
			{state.hasSizes && <Sizes
				options={Object.keys(state.sizes)}
				clickHandler={key => set(p => ({ ...p, selectedSize: key }))}
				selected={state.selectedSize}
			/>}
			<SInfo> {getSpecs()} </SInfo>
			<SItems>
				<SGrid>
					{getThumbnails()}
				</SGrid>
			</SItems>
		</SMenu>
	)
}
